module.exports = __webpack_public_path__ + "img/sheep-v.51f598c7.png";